import { Pipe, PipeTransform } from '@angular/core';
import { timer } from 'rxjs';
import { map, mapTo, take, takeUntil } from 'rxjs/operators';

@Pipe({
  name: 'maskPin',
})
export class MaskPinPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): any {
    let count = 0;
    return timer(0, 1000).pipe(
      map(() => {
        count++;
        if (count > 1) {
          return '*';
        }
        return value;
      }),
      take(2)
    );
  }
}
